<template>
  <ComboboxBase
    :name="label"
    :options="options"
    :error="error"
    :placeholder="placeholder"
    :value="value"
    :label="optionTextName"
    :required="isRequired"
    :hide-messages="hideMessages"
    :show-clear-button="showClearButton"
    :disable-auto-focus="disableAutoFocus"
    :announced-field-cleared="announcedFieldCleared"
    @updateInput="updateEntry"
    @clearEntry="clearEntry"
  ></ComboboxBase>
</template>

<script>
import ComboboxBase from "~/components/combobox/ComboboxBase.vue";

export default {
  name: "ValueSelect",
  components: {
    ComboboxBase,
  },

  props: {
    isRequired: { type: Boolean, default: false },
    error: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    value: { type: Object, default: () => undefined },
    options: { type: Array, required: true },
    optionValueName: { type: String, default: "id" },
    optionTextName: { type: String, default: "name" },
    hideMessages: { type: Boolean, default: false },
    showClearButton: { type: Boolean, default: false },
    disableAutoFocus: { type: Boolean, default: false },
    announcedFieldCleared: { type: Boolean, default: true },
  },
  methods: {
    clearEntry() {
      this.$emit("value-selected", null);
    },
    updateEntry(newValue) {
      this.$emit("value-selected", newValue);
    },
  },
};
</script>
